import { Pipe, PipeTransform } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, distinctUntilChanged, Subject } from 'rxjs';
import { DashboardProfileContextService } from '../..';
import { UserType } from '../domain/entities/profile-user.model';

@UntilDestroy()
@Pipe({
  name: 'rmaUserTypeUrl',
  pure: false,
  standalone: true,
})
export class UserTypeUrlPipe implements PipeTransform {
  private latestValue: string | null = null;
  private path = new Subject<string>();

  public constructor(private readonly profileContextService: DashboardProfileContextService) {
    const userType$ = this.profileContextService.profileUserType$;

    combineLatest([userType$, this.path.asObservable().pipe(distinctUntilChanged())])
      .pipe(untilDestroyed(this))
      .subscribe(([type, path]) => this._updateLatestValue(type, path));
  }

  public transform(value: string, override?: UserType): string | null {
    if (override) {
      return this.makeUrl(override, value);
    }

    this.path.next(value);
    return this.latestValue;
  }

  private _updateLatestValue(userType: UserType, value: string): void {
    this.latestValue = this.makeUrl(userType, value);
  }

  private makeUrl(userType: UserType, path: string): string {
    const cleanedPath = path.startsWith('/') ? path.substring(1) : path;
    const userTypePath = userType === UserType.Agent ? 'agent' : 'agency';
    return `/${userTypePath}/${cleanedPath}`;
  }
}
